import React from "react";

const pageStartedAt = Date.now();
const startedAtByScope = new Map();

function markStarted(scope) {
  const key = String(scope || "public-form");
  if (!startedAtByScope.has(key)) startedAtByScope.set(key, pageStartedAt);
  return startedAtByScope.get(key);
}

function readHoneypot(scope) {
  if (typeof document === "undefined") return "";
  const key = String(scope || "public-form");
  const inputs = Array.from(
    document.querySelectorAll("[data-public-form-honeypot]"),
  );
  const input =
    inputs.find((element) => element.dataset.publicFormHoneypot === key) ||
    inputs[0];
  return typeof input?.value === "string" ? input.value : "";
}

async function issueProof(scope) {
  const response = await fetch("/api/form-proof", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scope }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.proof) {
    throw new Error("Unable to prepare secure form submission");
  }
  return result.proof;
}

export async function withPublicFormProof(scope, payload = {}) {
  const proof = await issueProof(scope);
  return {
    ...payload,
    _formProof: proof,
    _formStartedAt: markStarted(scope),
    companyWebsite: readHoneypot(scope),
  };
}

export async function secureFormData(scope, formData) {
  const proof = await issueProof(scope);
  const startedAt = markStarted(scope);
  const honeypot = readHoneypot(scope);
  formData.set("_formProof", proof);
  formData.set("_formStartedAt", String(startedAt));
  formData.set("companyWebsite", honeypot);
  return {
    formData,
    headers: {
      "X-Form-Proof": proof,
      "X-Form-Started-At": String(startedAt),
      "X-Form-Honeypot": honeypot,
    },
  };
}

export function PublicFormHoneypot({ scope }) {
  markStarted(scope);
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label>
        Leave this field empty
        <input
          type="text"
          name="companyWebsite"
          data-public-form-honeypot={scope}
          tabIndex="-1"
          autoComplete="off"
          defaultValue=""
        />
      </label>
    </div>
  );
}

